// Import der drei Teile
import { ratgeberContent } from './ratgeberContent';
import { ratgeberContentPart2 } from './ratgeberContentPart2';
import { ratgeberContentPart3 } from './ratgeberContentPart3';

// Zusammenführen aller Teile
export const allRatgeberContent = {
  ...ratgeberContent,
  ...ratgeberContentPart2,
  ...ratgeberContentPart3
};
